export enum CreateServiceErrors {
  INCORRECT_NAME = 'Не корректное название услуги.',
  INCORRECT_PRICE = 'Не корректная стоимость услуги.',
  INCORRECT_CATEGORY = 'Выберите категорию услуги.',
  INCORRECT_DURATION = 'Укажите время предоставления услуги.',
  INCORRECT_EMPLOYEES = 'Выберите хотя бы одного сотрудника.',
}
